export default "__VITE_PUBLIC_ASSET__83f42dfa__"